import { PracticeFunction } from "app/models/practice"
import { Action, Types } from "./functions.actions"

export type FunctionState = {
  data: PracticeFunction[] | undefined
  function: PracticeFunction | undefined
  errors: {}
  loading: boolean
}

const initialState: FunctionState = {
  data: undefined,
  function: undefined,
  errors: {},
  loading: false,
}

export default (state = initialState, action: Action): FunctionState => {
  switch (action.type) {
    case Types.GET:
      return {
        ...state,
        loading: true,
      }

    case Types.GET_SUCCESS:
      return {
        ...state,
        data: action.payload.data,
        loading: false,
      }

    case Types.GET_FAIL:
      return {
        ...state,
        errors: action.payload.errors,
        loading: false,
      }

    case Types.PATCH:
      return {
        ...state,
        loading: true,
      }

    case Types.PATCH_SUCCESS:
      return {
        ...state,
        data: [
          ...state.data!.map(item => {
            if (item.id === action.payload.data.id) {
              return action.payload.data
            }
            return item
          }),
        ],
        loading: false,
      }

    case Types.PATCH_FAIL:
      return {
        ...state,
        errors: action.payload.errors,
        loading: false,
      }

    case Types.PATCH_ORDER:
      return {
        ...state,
        loading: true,
      }

    case Types.PATCH_ORDER_SUCCESS:
      return {
        ...state,
        loading: false,
      }

    case Types.PATCH_ORDER_FAIL:
      return {
        ...state,
        errors: action.payload.errors,
        loading: false,
      }

    case Types.POST:
      return {
        ...state,
        loading: true,
      }

    case Types.POST_SUCCESS:
      return {
        ...state,
        data: state.data ? [...state.data, action.payload.data] : [action.payload.data],
        function: action.payload.data,
        loading: false,
      }

    case Types.POST_FAIL:
      return {
        ...state,
        errors: action.payload.errors,
        loading: false,
      }

    default:
      return state
  }
}
